<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      Dashboard
      <!-- <small>Optional description</small> -->
    </h1>
    <ol class="breadcrumb">
      <li>
        <a href="#"> <i class="fa fa-dashboard"></i> Home</a>
      </li>
      <li class="active">Dashboard</li>
    </ol>
  </section>

  <!-- Main content -->
  <!-- <section class="content container-fluid"> -->

  <!--------------------------
        | Your Page Content Here |
        -------------------------->
  <!-- <h1>
        Dashboard
        <small>Control panel</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Dashboard</li>
      </ol>
    </section> -->

  <!-- Main content -->
  <section class="content">
    <!-- Small boxes (Stat box) -->
    <dashboard-header></dashboard-header>

    <dashboard-parking [group]="groupName" *ngIf="groupName != groupTypes.CUSTOMER"></dashboard-parking>
    <!-- Main row -->

    <div class="box box-success" *ngIf="groupName != groupTypes.CUSTOMER">
      <div class="box-header with-border">
        <div class="form-group">
          <h3 class="box-title" style="display: inline;">Statistics</h3>
          <input class="form-control" style="display: inline;width: 25%; margin-left: 1em;"
            [ngModelOptions]="{ standalone: true }" #drp="bsDaterangepicker" [bsConfig]="bsConfig" bsDaterangepicker
            [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChanged()" readonly />
        </div>
      </div>
      <div class="box-body">
        <div class="clearfix"></div>
        <!-- Left col -->
        <section *ngIf="groupName == groupTypes.ADMIN" class="col-lg-6 connectedSortable">
          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header">
              <i class="fa fa-money"></i>

              <h3 class="box-title">
                Revenues
              </h3>
            </div>

            <div class="box-body border-radius-none">
              <div class="chart">
                <ngx-charts-bar-vertical-stacked *ngIf="revenueChart" [scheme]="sharedSettings.colorScheme"
                  [customColors]="[
                    {
                      name: 'pass',
                      value: passColor
                    }
                  ]" [view]="sharedSettings.view" [results]="revenueChart" [roundDomains]="sharedSettings.roundDomains"
                  [legendTitle]="'Benficiaries'" [gradient]="sharedSettings.gradient" [xAxis]="sharedSettings.showXAxis"
                  [yAxis]="sharedSettings.showYAxis" [legend]="true" [showXAxisLabel]="sharedSettings.showXAxisLabel"
                  [showYAxisLabel]="sharedSettings.showYAxisLabel" [xAxisLabel]="'Parking places'"
                  [yAxisLabel]="'Revenue - KD'" (select)="onSelectRevenuesChart($event)">
                  <ng-template #tooltipTemplate let-model="model">
                    <p style="margin-top: 5px">
                      {{ model.name }}
                    </p>
                    <p>{{ model.value | number: "1.3" }} KD</p>
                  </ng-template>
                </ngx-charts-bar-vertical-stacked>
              </div>

              <!-- /.box-body-->
            </div>
            <div *ngIf="revenuesLoading" class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <!-- /.box -->
        </section>
        <!-- /.Left col -->
        <!-- right col (We are only adding the ID to make the widgets sortable)-->
        <section class="col-lg-6 connectedSortable">
          <!-- solid sales graph -->
          <div class="box box-solid">
            <div class="box-header">
              <i class="fa fa-th"></i>

              <h3 class="box-title">
                Visitors
              </h3>

              <!-- <div class="box-tools pull-right">
                <button type="button" class="btn bg-teal btn-sm" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn bg-teal btn-sm" data-widget="remove"><i class="fa fa-times"></i>
                </button>
              </div> -->
            </div>
            <div class="box-body border-radius-none">
              <div class="chart">
                <ngx-charts-bar-vertical-stacked [roundDomains]="sharedSettings.roundDomains"
                  [view]="sharedSettings.view" [customColors]="[
                    {
                      name: 'Registered',
                      value: passColor
                    }
                  ]" *ngIf="visitorsChart && visitorsHours.length == 0" [scheme]="sharedSettings.colorScheme"
                  [results]="visitorsChart" [gradient]="sharedSettings.gradient" [xAxis]="sharedSettings.showXAxis"
                  [yAxis]="sharedSettings.showYAxis" [legend]="sharedSettings.showLegend"
                  [showXAxisLabel]="sharedSettings.showXAxisLabel" [showYAxisLabel]="sharedSettings.showYAxisLabel"
                  [xAxisLabel]="'Parking places'" [yAxisLabel]="'Visitors'" (select)="onSelectVisitorsChart($event)">
                </ngx-charts-bar-vertical-stacked>

                <ngx-charts-line-chart *ngIf="visitorsHours.length != 0" [view]="sharedSettings.view" [customColors]="[
                    {
                      name: 'pass',
                      value: passColor
                    }
                  ]" [scheme]="sharedSettings.colorScheme" [results]="visitorsHours"
                  [gradient]="sharedSettings.gradient" [xAxis]="sharedSettings.showXAxis"
                  [yAxis]="sharedSettings.showYAxis" [legend]="true" [showXAxisLabel]="sharedSettings.showXAxisLabel"
                  [showYAxisLabel]="sharedSettings.showYAxisLabel" (click)="onSelectVisitorsChart($event)">
                </ngx-charts-line-chart>
              </div>
            </div>
            <!-- /.box-body -->
            <div *ngIf="visitorsLoading" class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <!-- /.box -->
        </section>
        <!-- right col -->

        <section *ngIf="groupName == groupTypes.ADMIN" class="col-lg-6 connectedSortable">
          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header">
              <!-- tools box -->
              <div class="pull-right box-tools">
                <!-- <button type="button" class="btn btn-primary btn-sm daterange pull-right" data-toggle="tooltip"
                        title="Date range">
                  <i class="fa fa-calendar"></i></button>
                <button type="button" class="btn btn-primary btn-sm pull-right" data-widget="collapse"
                        data-toggle="tooltip" title="Collapse" style="margin-right: 5px;">
                  <i class="fa fa-minus"></i></button> -->
              </div>
              <!-- /. tools -->

              <i class="fa fa-money"></i>

              <h3 class="box-title">
                Top up
              </h3>
            </div>
            <div class="box-body">
              <div class="chart">
                <ngx-charts-bar-vertical [roundDomains]="sharedSettings.roundDomains" [view]="sharedSettings.view"
                  *ngIf="topupChart" [results]="topupChart" [gradient]="sharedSettings.gradient"
                  [xAxis]="sharedSettings.showXAxis" [yAxis]="sharedSettings.showYAxis"
                  [legend]="sharedSettings.showLegend" [showXAxisLabel]="sharedSettings.showXAxisLabel"
                  [showYAxisLabel]="sharedSettings.showYAxisLabel" [xAxisLabel]="'Parking places'"
                  [yAxisLabel]="'Income - KD'">
                  <ng-template #tooltipTemplate let-model="model">
                    <p style="margin-top: 5px">
                      {{ model.name }}
                    </p>
                    <p>{{ model.value | number: "1.3" }} KD</p>
                  </ng-template>
                </ngx-charts-bar-vertical>
              </div>
            </div>
            <!-- /.box-body-->
            <div *ngIf="revenuesLoading" class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <!-- /.box -->
        </section>

        <section class="col-lg-6 connectedSortable">
          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header">
              <!-- tools box -->
              <div class="pull-right box-tools">
                <!-- <button type="button" class="btn btn-primary btn-sm daterange pull-right" data-toggle="tooltip"
                          title="Date range">
                    <i class="fa fa-calendar"></i></button>
                  <button type="button" class="btn btn-primary btn-sm pull-right" data-widget="collapse"
                          data-toggle="tooltip" title="Collapse" style="margin-right: 5px;">
                    <i class="fa fa-minus"></i></button> -->
              </div>
              <!-- /. tools -->

              <i class="fa fa-money"></i>

              <h3 class="box-title">
                Average time
              </h3>
            </div>
            <div class="box-body">
              <div class="chart">
                <ngx-charts-bar-vertical [roundDomains]="sharedSettings.roundDomains" [view]="sharedSettings.view"
                  *ngIf="averageTimeChart" [scheme]="sharedSettings.colorScheme" [results]="averageTimeChart"
                  [gradient]="sharedSettings.gradient" [xAxis]="sharedSettings.showXAxis"
                  [yAxis]="sharedSettings.showYAxis" [legend]="sharedSettings.showLegend"
                  [showXAxisLabel]="sharedSettings.showXAxisLabel" [showYAxisLabel]="sharedSettings.showYAxisLabel"
                  [xAxisLabel]="'Parking places'" [yAxisLabel]="'Average Time Spent - Mins'"></ngx-charts-bar-vertical>
              </div>
            </div>
            <!-- /.box-body-->
            <div *ngIf="averageLoading" class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <!-- /.box -->
        </section>
      </div>
    </div>
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->
